import React from 'react';
import PropTypes from 'prop-types';
import { momentObj } from 'react-moment-proptypes';

import DateInput from '@/shared/components/input/DateInput';
import moment from 'moment';
import intlShape from '@/shared/utils/intlShape';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';

const DatePart = ({ value, onChange, showValidation, intl, disabled, inputCols }) => (
  <FormGroupPart label={messages.Date} inputCols={inputCols} invalid={showValidation && !value}>
    <DateInput
      value={moment.utc(value)}
      onChange={date => onChange(moment.utc(date).toDate())}
      placeholder={intl.formatMessage(messages.Date)}
      disabled={disabled}
    />
  </FormGroupPart>
);

DatePart.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), momentObj]),
  onChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool,
  inputCols: PropTypes.string,
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
};
DatePart.defaultProps = {
  value: moment
    .utc()
    .startOf('day')
    .toDate(),
  showValidation: false,
  inputCols: 'col-sm-10',
  disabled: false,
};
export default DatePart;
